import axios from "axios";

import { BASEURL } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";

export function ApiMonthlyReports() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const fileAuthAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    responseType: "arraybuffer",
  });

  const url = BASEURL + "report/";
  return {
    MonthlyReportNotificationApproval: (record) =>
      authAxios.post(url + "MonthlyReportNotificationApproval/", record),

    GetMonthlyReportExcel: (id) =>
      fileAuthAxios.get(url + "GenerateNazamExcelReport/" + id),

    GetMonthlyReportPdf: (id) =>
      authAxios.get(url + "GenerateNazamPdfReport/" + id),
  };
}
